const $ = require('jquery');

const config = {
  focusDelaySpeed: 300,
};

class SearchCore {
  constructor() {
    this._setSearchState = this._setSearchState.bind(this);
    this._focusOnSearch = this._focusOnSearch.bind(this);
    this.openSearch = this.openSearch.bind(this);
    this.closeSearch = this.closeSearch.bind(this);
    this.clearSearchField = this.clearSearchField.bind(this);
    this.checkSearchFocus = this.checkSearchFocus.bind(this);
  }

  _setExpanderState(open) {
    const $header = $('.Header3');
    const $searchBox = $('.SearchBox');

    // collapse both, then collapse the 1st left
    $header
      .find('.Header3__collapser')
      .toggleClass('Header3__collapser--collapse', open)
      .eq(0)
      .toggleClass('Header3__collapser--collapse-left', open);

    // without the following timeout, the animation for the above class toggling
    // might not complete, and the search text field will not expand
    setTimeout(() => {
      $header
        .find('.Header3__expander')
        .toggleClass('Header3__expander--expand', open);
      $searchBox
        .find('.SearchBox__options')
        .toggleClass('SearchBox__options--open', open);
    }, 100);
  }

  _setSearchState(open) {
    this._setExpanderState(open);
    $(document).trigger('searchState', open);
  }

  _isFocus() {
    const $searchBox = $('.SearchBox');
    const $searchInput = $searchBox.find('.SearchBox__input');
    const $searchButton = $searchBox.find('.SearchBox__button');
    const focusOnSearch =
      $searchInput.is(':focus') || $searchButton.is(':focus');

    return focusOnSearch;
  }

  _focusOnSearch() {
    if (!this._isFocus()) {
      $('.SearchBox .SearchBox__input').focus();
    }
  }

  openSearch() {
    this._setSearchState(true);
    setTimeout(this._focusOnSearch, config.focusDelaySpeed);
  }

  closeSearch() {
    const closeCover = !($('.SearchBox__input').val() || this._isFocus());
    if (closeCover) {
      this._setSearchState(false);
    }
  }

  clearSearchField(event) {
    event.preventDefault();
    $('.SearchBox__input').val('').blur();
    $(document).trigger('clearSearchField');
    this.closeSearch();
  }

  // To validate if the user is already focused on searchbar
  checkSearchFocus() {
    const isSearchFocused = $('.SearchBox__input').is(':focus');
    if (isSearchFocused) {
      this.openSearch();
    }
  }
}

module.exports = new SearchCore();
